export default "__VITE_ASSET__qTFgXSY8__"